import React from 'react';
import { Calendar, MapPin, Package } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const iconMap = {
  calendar: Calendar,
  'map-pin': MapPin,
  package: Package
};

const ServiceOptions = ({ services, onServiceClick }) => {
  return (
    <div className="py-16 px-4 bg-white">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-3xl font-bold text-gray-900 mb-12 text-center">
          How can I get my phone repaired?
        </h2>
        
        <div className="grid md:grid-cols-3 gap-8">
          {services.map((service) => {
            const IconComponent = iconMap[service.icon];
            return (
              <Card 
                key={service.id} 
                className="border-0 shadow-sm hover:shadow-lg transition-all duration-300 cursor-pointer group"
                onClick={() => onServiceClick(service)}
              >
                <CardContent className="p-6">
                  <div className="mb-4 overflow-hidden rounded-lg">
                    <img 
                      src={service.image} 
                      alt={service.title}
                      className="w-full h-48 object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                  </div>
                  <div className="flex items-center mb-3">
                    <div className="p-2 bg-blue-50 rounded-lg">
                      <IconComponent className="w-6 h-6 text-blue-600" />
                    </div>
                  </div>
                  <h3 className="text-xl font-semibold text-gray-900 mb-2">
                    {service.title}
                  </h3>
                  <p className="text-gray-600">
                    {service.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ServiceOptions;